<template>
  <div style="padding-top: 72px">

    <div class="sg-header-input d-flex ">
    
      <v-row no-gutters
        :class="['sg-search-input align-center', { 'sg-search-input-dark': $vuetify.theme.dark  }, {'sg-search-input-focused elevation-1 mx-4': focused} ]"
       @click.prevent.stop="$refs.search.focus()">

        <v-col class="align-center">
          <div v-if="label" class="primary--text">{{label}},</div>
          <input id="search" ref="search" :value="searchText" @input="searchText = $event.target.value"
                       
            placeholder="Поиск адреса" 
            autofocus 
            @focus="focused = true"
            @blur="focused = false" 
            @click="focused = true" 
            autocomplete="off"

            @keydown.tab.stop.prevent="onSearchChanged"
            @keyup.enter.stop.prevent="onSearchChanged"

            />
        </v-col>
        <!--    <v-progress-circular v-if="enteringLoading" color="primary" indeterminate /> -->
        <v-icon v-if="focused && (searchText || selectedAutocompItem)" icon @click="clear">mdi-close</v-icon>

        <v-icon v-else>mdi-magnify</v-icon>
      </v-row>

     </div>


    <sg-loader :loading="enteringLoading">
      <sg-wire-addresses v-if="!abonents || abonents.length == 0" :autocompList="autocompList" :canSkip="canSkip" @select="selectAutoComp($event)" @skip="$emit('skip')"/>
      <sg-wire-services v-else :services="abonents" @wire="$emit('wire', $event)"/>
    </sg-loader>

  </div>
</template>

<script>

  import SgWireAddresses from './SgWireAddresses'
  import SgWireServices from './SgWireServices'
  import { debounce } from 'lodash'
/*   import api from '../api' */

  export default {

    props: {
      canSkip: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    components: {
      SgWireServices, SgWireAddresses
    },

    created() {
      this.debouncedAutocompete = debounce(this.getAutocomlete, 500)
    },
    
    mounted() {
      this.$refs.search.focus()
    },

    watch: {
      searchText() {
        this.onSearchChanged()
      },
      selectedAutocompItem() {
        this.abonents = []
        this.autocompList = null
      }
    },
    
    computed: {
      label() {
        if (this.selectedAutocompItem) {
          return this.selectedAutocompItem.city
        }
        return ''
      }
    },

    data() {
      return {

        selectedAutocompItem: null,
        autocompList: null,

        searchText: '',
        focused: true,

        abonents: [],
 
        enteringLoading: false,

        searchRules: [
          v => /[А-Яа-яЁё.\-\d_\/()NI,;\s]+$/.test(v) ||
          'Введеный адрес содержит недопустимые символы. Допускаются только буквы русского алфавита, цифры, буквы и следующие символы: .,;_/()-NI'
        ],

        error: false,
        errorMessage: '',
      }
    },
    methods: {

      onSearchChanged() {
        if (this.lastPromise) {
          this.lastPromise.cancel()
        }
        this.abonents = []
        this.autocompList = null

        let newVal = this.searchText

        if (newVal && (newVal.trim().length > 2)) {

          this.enteringLoading = true
          this.debouncedAutocompete()

        } else {
          this.enteringLoading = false

          if (!newVal || newVal.length == 0) {

            if (this.selectedAutocompItem) {

              this.searchText = this.selectedAutocompItem.city + ', '
              this.selectedAutocompItem = null
            } else {
              this.clear()
            }
          }
        }
      },

      clear() {
        if (this.lastPromise) {
          this.lastPromise.cancel()
        }
        this.abonents = []
        this.autocompList = null

        this.selectedAutocompItem = null
        this.searchText = ''
        this.focused = true
      },

      formatItem(item, full) {
        if (item) {
          let arr = []
          if (full && item.city) arr.push(item.city)
          if (item.street) arr.push(item.street)
          if (item.building) arr.push(item.building)
          if (item.apartment) arr.push(item.apartment)
          return arr.join(', ')
        }
        return ''
      },


      getAutocomlete() {

        let searchText = this.searchText

        if (this.selectedAutocompItem) {
          searchText = this.selectedAutocompItem.city + ', ' + searchText
        }

        if (!searchText.trim()) return

        if (this.lastPromise) {
          this.lastPromise.cancel()
        }

        let cancelable = this.$api.autocompleteCancellable(searchText)

        this.lastPromise = cancelable

        cancelable.promise
          .then(autocomp => {
            if (autocomp && autocomp.options && autocomp.options.length == 1 && autocomp.options[0].len > 0) {
              let cancelable2 = this.$api.abonentsCancellable(searchText)
              this.lastPromise = cancelable2
              return cancelable2.promise
                .then(servs => {
                  autocomp.options[0].servs = servs
                  return autocomp
                })
            }
            return autocomp
          })
          .then(res => {
            Object.freeze(res)
            if (res.options.length == 1 && res.options[0].servs && res.options[0].servs.length > 0) {
              this.abonents = res.options[0].servs

            }
            this.autocompList = res
            this.enteringLoading = false
          })
          .catch(error => {
            if (error.message != 'canceled') {
              this.enteringLoading = false
              this.$eventBus.$emit('error', error)
            }
          })
      },


      fetchAddrAbonent(item) {
        if (!item) return

        if (this.lastPromise) {
          this.lastPromise.cancel()
        }
        this.abonents = null
        this.enteringLoading = true

        let addressString = this.formatItem(item, true)

        this.$api.abonents(addressString)
          .then(abonentsList => {
            Object.freeze(abonentsList)
            this.abonents = abonentsList
          })
          .catch(error => {
            this.$eventBus.$emit('error', error)
          })
          .finally(() => {
            this.enteringLoading = false
          })
      },

      selectAutoComp(item) {
        if (item.len && item.len > 0) {
          if (this.lastPromise) {
            this.lastPromise.cancel()
          }
          this.fetchAddrAbonent(item)
          this.focused = false
        } else {
          this.selectedAutocompItem = item

          let itemFormatted = this.formatItem(item)

          this.searchText = itemFormatted ? itemFormatted + ', ' : ''
          this.$refs.search.focus()
        }
      }

    }
  }
</script>

<style>
 
  .sg-search-input {
 
    min-height: 56px;
    padding: 0px 12px 0px;
    transition: margin 0.2s, border-radius 0.2s;
    background-color: #FFFFFF;

    border-bottom: 1px solid #E0E0E0;
  }

  .sg-search-input input {
    outline: none;
    width: '100%'
  }

  .sg-search-input-focused {

    margin: 12px 12px 0px;

    border-radius: 5px;
    border-bottom: 0px;
  }

  .sg-search-input-dark {
    background-color: #424242 !important;
    border-bottom: 0px !important;
  }




  .sg-search-input-dark input {
    color: #FFFFFF
  }



  .sg-header-input {
    height: 72px; 
    max-height: 72px; 
    min-height: 72px; 
    position: fixed; 
    top: 0px; 
    left: 0px; 
    width: 100%; 
    z-index: 1
  }

  .sg-light {
    background-color: #fff;
    /*    z-index: 256; */
  }

  .sg-dark-secondary {
    background-color: #424242;
    /* z-index: 256; */
  }

  .sg-dark-primary {
    background-color: #000;
  }

</style>